module.exports = __webpack_public_path__ + "static/media/tick.df27b9b8.svg";